import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import FlexContainer from "../components/flex-container.js";
import SidebarLeft from "../components/sidebar-left.js";
import SidebarRight from "../components/sidebar-right.js";
import Container from '../components/container.js'
import TitreAxe from '../components/titre-axe.js'
import SvgLieu from "../../images/lieu.svg"
import BtnMarieSavonnieresDeLaTroche from '../components/btn-marie-savonnieres-de-la-troche.js'
import BtnLouisFortier from '../components/btn-louis-fortier.js'
import BtnCapsuleOdho from '../components/btn-capsule-odho.js'
import BtnOho from '../components/btn-oho.js'
import InfoBox from '../components/info.js'
import PhotoIlot from './../../images/A4Lieu_gauche_1_sphere.jpg'
import styles from '../components/index.module.css';
import ImageFooter from '../components/image-footer-axe4.js'
import FragAxe4 from '../components/frag-axe4.js'

const SecondPage = () => (
    <div>
    <FlexContainer>
        <Helmet bodyAttributes={{class: 'visions'}}/>
        <SidebarLeft>
          <div style={{width : "100%", display: "flex", flexDirection: "column", justifyContent: "space-between",alignItems: "flex-end", paddingBottom: "1.45rem"}}>
            <div style={{maxWidth: "520px", width: "70%", height: "auto", alignSelf: "center"}}>
                <div className='metadata--wrapper'>
                    <img src={PhotoIlot} alt=""/>
                    <InfoBox>La sphère à bout de bras (artiste à retracer). Photographe inconnu, Archives de l&#39;Ilôt Fleurie, ca2003.</InfoBox>
                </div>
            </div>
        </div>
        </SidebarLeft>
        <Container>
            <TitreAxe>Visions</TitreAxe>
            <SvgLieu/>
            <h1>Ilôt Fleurie</h1>
            <p>Initialement situé dans l’axe des rues Fleurie et De la Chapelle, l'Îlot Fleurie est une installation horticole et artistique qui prend forme à l’été 1991. Née d’une initiative citoyenne en réaction à la dégradation d’un terrain vague au coeur du quartier Saint-Roch, l'Îlot Fleurie gagne en appuis citoyens et devient un lieu mixte. Pour les résidents du quartier et les passants, il sert de jardin communautaire, de place publique et d’espace de rassemblement; pour les artistes qui s'y retrouvent, il est à la fois un lieu de création, de rencontre et de diffusion. Forcé de déménager sous les bretelles de l’autoroute Dufferin-Montmorency en 1998, l’Îlot devient, lors du Sommet des Amériques en 2001, un important lieu de rassemblement pour les militants.</p>
            <FragAxe4/>
        </Container>
        <SidebarRight>
            <BtnCapsuleOdho/>
            <BtnMarieSavonnieresDeLaTroche/>
            <BtnLouisFortier/>
            <BtnOho/>
        </SidebarRight>
    </FlexContainer>
    <ImageFooter/>
    </div>
    )

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/l-ilot-fleurie.js